const educationTimeline = [
  {
    title: "Georgian National University",
    highlighted:
      "Bachelor of Computer Science, Data Science and Artificial Intelligence",
    desc: " - Algorithms, Probability Theory and Statistics, Artificial Neural Networks, and Foundations of Artificial Intelligence for Scalable Intelligent Systems.",
    date: "Sep 2024 - Present",
  },
  {
    title: "BTU • Business and Technology University",
    highlighted: "AI Camp for Students - XR and Future Technologies",
    desc: " — Immersive technologies, including Augmented Reality (AR), Virtual Reality (VR), and Mixed Reality (MR), exploring their applications in various industries.",
    date: "Oct 2025 - Oct 2025",
  },
  {
    title: "TBC Bank",
    highlighted: "Web Development Fundamentals",
    desc: " — Semantic HTML5, responsive CSS and Sass with Flexbox and Grid, cross-browser compatibility, and Bootstrap.",
    date: "Apr 2024 - Jun 2024",
  },
  {
    title: "IT Academy Step Georgia",
    highlighted: "Software Development",
    desc: " — ASP, MS SQL Server Programming and Administration, Microsoft .NET Framework and C# Programming Language, JavaScript Programming Language and jQuery, creating web pages using HTML5 and CSS3.",
    date: "Apr 2020 - Nov 2023",
  },
];

export default educationTimeline;
